// removed by extract-text-webpack-plugin
module.exports = {"droparea":"wuVhu6uiLAxyD_P3ziuH_","icon":"_1Fj5ym5PAxMA6CXnrRGWXQ","dragover":"_2I6fuisFWlywRUKvbluwPH","btns":"_30R46sJx9S28rzm5v-UYfz","btn":"_3TYQU2iukBu-riGSBHjjWZ","msgDefault":"_2b1Rop6lBiewJt7jjJ0KRD","msgDrop":"aNN6utqn89vQblAska445","fileUpload":"_2BeKCMkNSaCeMMTgW0uT2m"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/ImageDropArea/style.css
// module id = 404
// module chunks = 37